<template>
    <div class="login-body">
        <div class="login-container">
            <div class="login-form">
                <div class="login-form-logo">
                    <img :src="$dynamicLogo.path || $logoPath">
                </div>
                <b-form @submit.prevent="doLogin">
                    <h5>Log In</h5>
                    <b-form-group label="Username">
                        <b-form-input v-model="input.username" name="loginUsername" placeholder="username"
                            required></b-form-input>
                    </b-form-group>
                    <b-form-group label="Password" class="password-form-group">
                        <b-form-input v-model="input.password" name="loginPassword" placeholder="password"
                            :type="passwordType" required></b-form-input>
                        <i :class=iconName @click="changePasswordType(1)"></i>
                    </b-form-group>
                    <b-button type="submit" name="loginBtn" class="pgi-btn" :disabled="isLoggingIn">
                        {{ isLoggingIn ? "Logging in..." : "Log In" }}
                    </b-button>
                    <div class="login-error-wrapper mt-3" v-if="errorMessage != ''">
                        <div class="text-danger">{{ errorMessage }}</div>
                    </div>
                </b-form>
                <p class="login-copyright">&copy; 2026 {{ $footerName }}.</p>
            </div>
            <div class="login-content" v-bind:style="{ 'background-image': 'url(' + $bgLoginPath + ')' }">
                <div class="login-content-wrapper">
                    <div class="login-sm-hidecontent">
                        <!-- <h1>Selamat Datang!</h1>
                        <p>Sistem Baru, Semangat Baru</p> -->
                    </div>
                </div>
            </div>
        </div>
        <b-modal id="modal-change-password" title="Ubah Password" no-close-on-esc no-close-on-backdrop
            :hide-header-close="isSubmitting">
            <b-form id="changePasswordForm" @submit.prevent="doChangePassword">
                <div class="modal-form-wrapper">
                    <div class="mb-4">Berdasarkan kebijakan perusahaan, anda diwajibkan mengubah password akun anda
                        sebelum mengakses sistem.</div>
                    <b-form-group label="Password Lama" class="password-form-group">
                        <b-form-input v-model="input.oldPassword" name="oldPassword" :type="oldPasswordType"
                            required></b-form-input>
                        <i :class="oldIconName" @click="changePasswordType(2)"></i>
                    </b-form-group>
                    <b-form-group label="Password Baru" class="password-form-group">
                        <b-form-input v-model="input.newPassword" name="newPassword" :type="newPasswordType" minlength=6
                            required></b-form-input>
                        <i :class="newIconName" @click="changePasswordType(3)"></i>
                    </b-form-group>
                    <b-form-group label="Ketik Ulang Password Baru" class="password-form-group">
                        <b-form-input v-model="input.confirmPassword" name="confirmPassword" :type="confirmPasswordType"
                            minlength=6 required></b-form-input>
                        <i :class="confirmIconName" @click="changePasswordType(4)"></i>
                    </b-form-group>
                </div>
            </b-form>
            <b-alert show variant="warning" class="mb-0">
                * Tidak diperbolehkan menggunakan password lama
            </b-alert>
            <template v-slot:modal-footer>
                <b-button variant="pgiBtn" name="changePasswordBtn" type="submit" form="changePasswordForm"
                    :disabled="isSubmitting">
                    {{ isSubmitting ? "Mengubah..." : "Ubah Password" }}
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'Login',
    data() {
        return {

            input: {
                username: '',
                password: '',
                userId: null,
                oldPassword: '',
                newPassword: '',
                confirmPassword: ''
            },

            isSubmitting: false,
            isLoggingIn: false,

            errorMessage: "",

            passwordType: 'password',
            iconName: 'fa fa-eye-slash',
            oldPasswordType: 'password',
            oldIconName: 'fa fa-eye-slash',
            newPasswordType: 'password',
            newIconName: 'fa fa-eye-slash',
            confirmPasswordType: 'password',
            confirmIconName: 'fa fa-eye-slash',

        }
    },
    methods: {

        doLogin() {

            let payload = new FormData()
            payload.append("username", this.input.username)
            payload.append("password", this.input.password)

            this.isLoggingIn = true
            this.errorMessage = ""
            this.$axios.post(`user/authenticate`, payload).then(response => {

                let data = response.data.data

                // Handle exp in seconds vs milliseconds
                let exp = data.exp
                if (exp && exp < 10000000000) {
                    exp = exp * 1000
                }

                // Handle raw cabang structure (support {first, second} from local backend as well as {id, name})
                let rawCabang = data.cabang || []
                let normalizedCabang = rawCabang.map(c => ({
                    id: c.id !== undefined ? c.id : c.first,
                    name: c.name !== undefined ? c.name : c.second
                }))

                localStorage.setItem("token", data.token)
                localStorage.setItem("role", data.role)
                localStorage.setItem("name", data.name)
                localStorage.setItem("exp", exp)
                localStorage.setItem("cabang", JSON.stringify(normalizedCabang))
                localStorage.setItem("menuTop", Array.isArray(data.menuTop) ? data.menuTop.join(',') : (data.menuTop || ''))
                localStorage.setItem("menuChildren", Array.isArray(data.menuChildren) ? data.menuChildren.join(',') : (data.menuChildren || ''))
                localStorage.setItem("lapeksPassword", null)
                localStorage.setItem("isauthorized", 'false')

                if (localStorage.getItem("version") === null) {
                    localStorage.setItem("reload", 1)
                    localStorage.setItem("version", data.version)
                } else {
                    if (localStorage.getItem("version") !== data.version) {
                        localStorage.setItem("reload", 1)
                    }

                    localStorage.setItem("version", data.version)
                }

                // Setup activeCabang for display
                let activeCabang = "Tanpa Cabang"
                let activeCabangId = 0

                if (normalizedCabang.length == 1) {
                    activeCabang = normalizedCabang[0].name
                    activeCabangId = normalizedCabang[0].id
                }
                else if (normalizedCabang.length > 1) {
                    activeCabang = "Multi Cabang"
                    activeCabangId = normalizedCabang[0].id
                }

                localStorage.setItem("activeCabang", activeCabang)
                localStorage.setItem("activeCabangId", activeCabangId)
                this.$axios.defaults.headers.common['Authorization'] = data.token
                this.$router.push("/dashboard")

            })
                .catch(error => {
                    console.log(error)
                    let reason = error.response.data.reason
                    console.log(error.response)

                    if (reason == "CHANGE-PASSWORD-REQUIRED") {

                        this.input.userId = error.response.data.data.id
                        this.$bvModal.show("modal-change-password")

                    }
                    else if (reason == "ERROR-LOCKED") {
                        this.errorMessage = "User ini telah dilock. Mohon hubungi HO untuk keterangan lebih lanjut."
                    }
                    else if (reason == "ERROR-NOT-FOUND") {
                        this.errorMessage = "Username atau password anda salah!"
                    }
                    else if (reason == "END-OF-DAY") {
                        this.errorMessage = "Anda sudah tidak dapat masuk pada saat ini (22:00 - 06:00)"
                    }
                    else {
                        this.$helper.toastErr(this, reason)
                    }

                })
                .finally(() => {
                    this.isLoggingIn = false
                })

        },

        doChangePassword() {

            let payload = new FormData()
            payload.append("userId", this.input.userId)
            payload.append("oldPassword", this.input.oldPassword)
            payload.append("newPassword", this.input.newPassword)
            payload.append("repeatNewPassword", this.input.confirmPassword)

            this.isSubmitting = true
            this.$axios.post("/user/changePassword", payload).then(response => {

                this.input.password = ""
                this.$bvModal.hide("modal-change-password")
                this.$helper.toastSucc(this, "Password berhasil diubah, silahkan login kembali!")

            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isSubmitting = false
                })

        },

        changePasswordType(id) {
            if (id == 1) {
                if (this.passwordType == 'password' && this.iconName == 'fa fa-eye-slash') {
                    this.passwordType = 'text'
                    this.iconName = 'fa fa-eye'
                }
                else {
                    this.passwordType = 'password'
                    this.iconName = 'fa fa-eye-slash'
                }
            } else if (id == 2) {
                if (this.oldPasswordType == 'password' && this.oldIconName == 'fa fa-eye-slash') {
                    this.oldPasswordType = 'text'
                    this.oldIconName = 'fa fa-eye'
                }
                else {
                    this.oldPasswordType = 'password'
                    this.oldIconName = 'fa fa-eye-slash'
                }
            } else if (id == 3) {
                if (this.newPasswordType == 'password' && this.newIconName == 'fa fa-eye-slash') {
                    this.newPasswordType = 'text'
                    this.newIconName = 'fa fa-eye'
                }
                else {
                    this.newPasswordType = 'password'
                    this.newIconName = 'fa fa-eye-slash'
                }
            } else {
                if (this.confirmPasswordType == 'password' && this.confirmIconName == 'fa fa-eye-slash') {
                    this.confirmPasswordType = 'text'
                    this.confirmIconName = 'fa fa-eye'
                }
                else {
                    this.confirmPasswordType = 'password'
                    this.confirmIconName = 'fa fa-eye-slash'
                }
            }
        },

    }
}

</script>